"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorBoundary = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
/* eslint-disable no-console */

class ErrorBoundary extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }
  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return {
      hasError: true
    };
  }
  componentDidCatch(error, info) {
    if (this.props.logErrorFunc) {
      this.props.logErrorFunc(error, info.componentStack);
    }
    console.warn(error, info);
  }
  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return this.props.fallback;
    }
    return this.props.children;
  }
}
exports.ErrorBoundary = ErrorBoundary;
ErrorBoundary.propTypes = {
  fallback: _propTypes.default.element,
  children: _propTypes.default.element,
  logErrorFunc: _propTypes.default.func
};